/**
 * Signe d'un extra ou d'un credit.
 *
 * CONVENTION : les montants sont stockes POSITIFS, le signe vient de `type`
 * (migration 20260310170000, « type carries sign semantics »). Ne jamais
 * enregistrer une valeur negative en base.
 *
 * Math.abs() d'abord : une vieille ligne deja stockee negative ne doit pas
 * recevoir le signe deux fois.
 *
 * @param {{type?: string}} extra  l'extra ou le credit (seul `type` est lu)
 * @param {*} raw                  le montant stocke (amount, costAccepted, …)
 * @returns {number}               negatif pour un credit, positif sinon, 0 si vide
 */
export const signedExtraAmount = (extra, raw) => {
  const val = Math.abs(parseFloat(raw) || 0);
  return extra?.type === 'credit' ? -val : val;
};

/**
 * Somme de LIGNES d'un extra, signee. Les lignes sont stockees relatives au
 * type (positif = dans le sens du type) et PEUVENT etre negatives : une ligne
 * de retrait dans un extra. Ici, pas de Math.abs : un sous-traitant dont les
 * lignes totalisent un montant negatif dans un extra recoit un avenant negatif.
 */
export const signedLinesAmount = (extra, sum) => {
  const val = parseFloat(sum) || 0;
  return extra?.type === 'credit' ? -val : val;
};

export default signedExtraAmount;
